<template>
	<div class="w-100">
		<span id="top_section"></span>
		<div v-if="is_load" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
    	<div class="p-4" v-if="error != ''">
      	<ErrorMessage :message="error" />
    	</div>
    	<template v-else>
    		<!-- HEADER -->
				<wrapper-mobile-view>
					<div class="w-100 bg-white py-3 px-4 border-b-semi-grey">
						<div class="w-100">
							<div class="row">
								<div class="col-1 align-self-center">
									<router-link :to="`/${getMerchant.code}`" class="d-inline-grid">
                    <img src="../../assets/img/icon/back.png" alt="icon-back" class="mt-1" width="20">
                  </router-link>
								</div>
								<div class="col-9 align-self-center">
									<p class="mb-0 body-1-2">{{$t('hotel.concierge.fitur.promo-for-you')}}</p>
								</div>
							</div>
						</div>
					</div>
				</wrapper-mobile-view>
				<block :height="57" />

				<!-- PROMO & GROUP VOUCHER LIST -->
				<div class="px-4">
					<div class="mb-4 w-100 radius-12 border-semi-grey" v-for="(item,index) in data">
						<flickity ref="flickity" class="" :options="freeScrollSlider" v-if="item.promotion_image.length > 0">
				      <div class="carousel-cell w-100" v-for="image in item.promotion_image">
			        	<div class="img-hover-zoom w-100">
		    					<img :src="image.image_url" class="radius-12-t w-100 object-fit slider-hover" style="height:200px;">
			        	</div>
				      </div>
				    </flickity>
						<img src="https://guestapps.s3-ap-southeast-1.amazonaws.com/noimage.png" v-else class="w-100 radius-12-t object-fit" style="height: 200px;">
						<div class="w-100 radius-12-t bg-green no-ws p-2" v-if="checkPromoValid(item)">
							<img src="../../assets/img/icon/discount-white.svg" width="20" class="d-inline-block align-middle mr-2"><p class="mb-0 d-inline-block align-middle text-white body-3-1">Promo valid until {{$formatDate(item.sale_date[0].end_date)}}</p>
						</div>
						<div class="px-3 py-4 border-b-semi-grey-dashed">
							<div class="row no-gutters" v-if="item.type == 'PROMOTION'">
								<div class="col-7">
									<p class="mb-0 sub-heading-1-1 pr-3">{{item.name}}</p>
								</div>
								<div class="col-5">
									<div class="w-100 px-2 py-3 box-shadow-promo text-center radius-12 border-semi-grey">
										<p v-if="item.formula[0].value_type == 'PERCENT'" class="mb-0 font-extrabold text-34 text-orange lh-1">{{item.formula[0].value}}%</p>
										<p v-else class="mb-0 font-extrabold text-20 text-orange">{{$formatCurrency(item.formula[0].value)}}</p>
										<p class="mb-0 font-bold text-24 text-orange lh-1">OFF</p>
									</div>
								</div>
							</div>
							<template v-else>
								<p class="mb-0 sub-heading-1-1">{{item.name}}</p>
							</template>
						</div>
						<div class="p-3">
							<div class="w-100">
								<div class="row slim-grid-row">
									<div class="col-8 align-self-center">
										<div class="px-2 py-1 bg-custom-light border-semi-grey radius-12 d-table">
											<template v-if="item.type == 'PROMOTION'">
												<p class="mb-0 body-3-1" v-if="item.merchant_pos.length > 1">{{item.merchant_pos.length}} {{$t('hotel.concierge.fitur.services-affected')}}</p>
												<div v-else class="w-100 no-ws">
													<img :src="item.merchant_pos[0].image_url" :alt="item.merchant_pos[0].name" class="img-fit d-inline-block align-middle rounded-circle mr-2" style="height:20px;width:20px;"><p class="mb-0 body-3-1 d-inline-block align-middle">{{item.merchant_pos[0].name}}</p>
												</div>
											</template>
											<p class="mb-0 body-3-1" v-else>{{countVoucher(item)}} {{$t('hotel.concierge.fitur.vouchers-available')}}</p>
										</div>
									</div>
									<div class="col-4 align-self-center">
										<button class="g-btn g-btn-primary g-btn-md w-100" @click="claimPromo(item)">{{$t('hotel.action.claim')}}</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- POPUP SELECT MODULE -->
				<popup-detail 
		    	direction="bottom" 
		    	:show="select_module.show"
		    	use_max_size
		    	wrapper_size="mobile"
		    	title="Select Services"
		    	@close="toggleSelectModule">
		    	<template slot="body">
			    	<div class="class p-4">
			    		<div class="mb-3 border-semi-grey radius-6 w-100 p-3" v-for="pos in select_module.data">
			    			<div class="row no-gutters">
			    				<div class="col-2 align-self-center"> 
			    					<img :src="pos.image_url" class="w-100 radius-6" :alt="pos.name">
			    				</div>
			    				<div class="col-7 align-self-center">
			    					<p class="mb-0 body-1-2 px-2">{{pos.name}}</p>
			    				</div>
			    				<div class="col-3 align-self-center">
			    					<button class="w-100 g-btn g-btn-primary-outline g-btn-md" @click="goToDetailModule(pos)">{{$t('hotel.action.claim')}}</button>
			    				</div>
			    			</div>
			    		</div>
			    	</div>
		    	</template>
		    </popup-detail>
			</template>
		</template>
	</div>
</template>
<script>
	import {get} from '@/services/index.js'
	import {mapGetters,mapMutations} from 'vuex'

	export default{
		data(){
			return{
				is_load: false,
				error: '',
				data: [],
				select_module:{
					show: false,
					data: [],
					promo_code: ''
				},
				freeScrollSlider: {
          initialIndex: 0,
          autoPlay: 4000,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: true,
          draggable: false,
          wrapAround: false,
          contain: false,
          cellAlign: 'left',
          groupCells: false
        },
			}
		},
		computed:{
			...mapGetters(['getMerchant'])
		},
		mounted(){
			this.loadFirstData()
		},
		methods:{
			...mapMutations(['setConciergeOrderPromoCode']),
			loadPromoList(){
				return new Promise((success,fail)=>{
					get("CONCIERGE","promo-code-option",{
						merchant_id: this.getMerchant.id
					}).then(response=>{
						let res = response.data
						if(res.success){
							success(res.data)
						}else{
							fail(res.message)
						}
					})
				})
			},
			loadFirstData(){
				this.is_load = true
				this.error = ''
				this.data = []
				Promise.all([
					this.loadPromoList()
				])
				.then(response=>{
					this.data = response[0].filter(x=>{
						if(x.promo_code){
							if(x.merchant_pos.length > 0){
								return x
							}else{
								return false
							}
						}else{
							return x
						}
					})

				})
				.catch(err=>this.error=err)
				.finally(()=>this.is_load=false)
			},
			toggleSelectModule(data = null,promo_code){
				this.select_module.show = !this.select_module.show
				if(this.select_module.show){
					this.select_module.data = data
					this.select_module.promo_code = promo_code
				}else{
					this.select_module.data = []
					this.select_module.promo_code = ''
				}
			},
			claimPromo(item){
				if(item.type == 'UPSELLING_SITE'){
						this.goToDetailModule(item,true)
				}else{
					if(item.merchant_pos.length>1){
						this.toggleSelectModule(item.merchant_pos,item.promo_code)
					}else{
						this.goToDetailModule(item.merchant_pos[0])
					}
				}
			},
			goToDetailModule(data,is_voucher=false){
				if(is_voucher){
					this.$router.push({
						name: 'GroupVoucher',
						params:{
							merchant_code: this.getMerchant.code,
							id: data.id
						}
					})
				}else{
					this.setConciergeOrderPromoCode(this.select_module.promo_code)
					this.$router.push(`/${this.getMerchant.code}/concierge/${data.slug}`)
				}
			},
			checkPromoValid(data){
				if(data.type == 'PROMOTION' && data.sale_date.length == 1){
					return true
				}
				return false
			},
			countVoucher(data){
				let total = 0
				data.group.forEach(group=>{
					total += group.upselling_product.length
				})
				return total
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/hotel/PromoList.vue